/*
 * File: /apps/web/src/enums/keyCodes.js
 * Project: tr-web
 * Created Date: 2020-09-29
 * Author: Raif
 *
 * Copyright (c) 2020 TaskRabbit, Inc
 */

export const keyCodes = {
  enter: "Enter",
  tab: "Tab",
  esc: "Escape",
  left: "ArrowLeft",
  up: "ArrowUp",
  right: "ArrowRight",
  down: "ArrowDown",
  space: " ",
};
